// extracted by mini-css-extract-plugin
export default {"table-actions-cont":"style_table-actions-cont__3O8mj"};